import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'react-recompose';
import { graphql } from '@apollo/react-hoc';
import noop from 'lodash/noop';
import { FormattedMessage, injectIntl } from 'react-intl';
import Header from '../../components/Header';
import Table from '../../components/Table';
import Toast from '../../components/Toast';
import { HEAccountQuery } from '../../utils/subscriptions';
import { authorizedImpersonatorWithRole } from '../Authorization';
import * as constants from '../Authorization/constants';
import AMConnectionsTable from './connections-table';
import messages from './messages';

import './styles.css';

class AMConnectionsView extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    loadMore: PropTypes.func.isRequired,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    warnings: PropTypes.array,
    heAccount: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  loadMore = () => {
    this.setState({ loading: true });
    this.props.loadMore('viewer.studentConnections').then(() => this.setState({ loading: false }));
  };

  render() {
    const { viewer, warnings, intl, heAccount: { activeSubscriptions } = {} } = this.props;
    const { loading } = this.state;
    const extendedLayout = (activeSubscriptions || []).includes('CAMINO');
    const { enabledFeatures } = viewer;
    const removeDiversityFilters = enabledFeatures?.includes(constants.REMOVE_DIVERSITY_FILTERS);

    if ((warnings && warnings.length > 0) || !viewer || !viewer.studentConnections) {
      return (
        <Toast
          active
          title="Temporarily Unavailable"
          kind="error"
          description={intl.formatMessage(messages.temporarilyUnavailable)}
          onDeactivate={noop}
        />
      );
    }

    return (
      <AMConnectionsTable
        connections={viewer.studentConnections}
        loading={loading}
        onLoadMore={this.loadMore}
        extendedLayout={extendedLayout}
        removeDiversityFilters={removeDiversityFilters}
      />
    );
  }
}

export const AMConnectionsViewComponent = AMConnectionsView;

const NoPermissions = () => (
  <Table basic="very" styleName="connections-table">
    <caption styleName="hidden"><FormattedMessage {...messages.tableCaption} /></caption>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell colSpan="6" styleName="table-header">
          <Header styleName="table-header">
            <FormattedMessage {...messages.noPermissions} />
          </Header>
        </Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  </Table>
);

export default compose(
  authorizedImpersonatorWithRole(
    [constants.IMPERSONATOR_SUPER_ADMIN_ROLE],
    { failure: NoPermissions },
  ),
  // inlining parts of withHEAccountSubscriptions as otherwise we see silent errors
  graphql(HEAccountQuery),
  withProps(({ data: { viewer } }) => ({
    heAccount: viewer?.heAccount,
  })),
  injectIntl,
)(AMConnectionsViewComponent);
